import styled from "styled-components";

export const GeneralContainer = styled.div`
  width: 100%;
  height: fit-content;
  background-color: ${({ theme }) => theme.neutral.white};
`;
